<template>
    <div v-show="show">
        <div class="availability-detail" v-if="store_count >= 0 && name != ''">
            <div class="title-wrapper">
                <div>
                    <h4>{{ name }}</h4>
                    <span>  ({{ distance }}km)</span>
                </div>
                <a class="link" :href="GOOGLE_MAP_LINK+address" target="_blank"><SvgDirection></SvgDirection>Take me there</a>
            </div>

            <div class="content"><SvgMarker></SvgMarker><span>{{ address }}</span></div>
            <div class="content"><SvgPhone></SvgPhone><a :href="'tel:' + phone"><span>{{ phone }}</span></a></div>
            <div><a href="javascript:void(0)" class="email-stockist" @click="emailStockist">Email Stockist</a></div>
            <div class="content alert" v-if="value === 'stockist'"><SvgAlert></SvgAlert><span>Please call to confirm stock availability</span></div>
        </div>
        <div class="availability-detail" v-else>
            <span>No store available in your location</span>
        </div>
        <a class="link more-options" @click="$emit('view-more-store')" v-show="store_count >= 0" :class="{ disabled: store_count == 0 }"> View {{ store_count }} more stores</a>
    </div>
</template>
  
<script>
import SvgDirection from './SvgDirection.vue';
import SvgMarker from './SvgMarker.vue'; 
import SvgPhone from './SvgPhone.vue';
import SvgAlert from './SvgAlert.vue';

export default {
        name: 'ProductAvailabilityDetail',
        components: {
            SvgDirection,
            SvgMarker,
            SvgPhone,
            SvgAlert
        },
        props: {
            name: String,
            address: String,
            phone: String,
            distance: String,
            value: String,
            store_count: Number,
            show: Boolean
        },
        data: function () {
            return {
                
            }
        },
        methods: {
            emailStockist: function () {
                const popup_btn = document.querySelector(".popup_stockist_enquiry--btn a[href*='#popup-']");
                const popup_form_name = document.querySelector("div[id^='popup-'] .popup_stockist_enquiry--form input[name='name']");
                const popup_form_email = document.querySelector("div[id^='popup-'] .popup_stockist_enquiry--form input[name='email']");
                const popup_form_phone = document.querySelector("div[id^='popup-'] .popup_stockist_enquiry--form input[name='phone']");

                if (popup_form_name) { popup_form_name.value = ""; }
                if (popup_form_email) { popup_form_email.value = ""; }
                if (popup_form_phone) { popup_form_phone.value = ""; }

                if (popup_btn) { popup_btn.click(); }
            }
        },
        mounted() {
        },
        created () {
            this.GOOGLE_MAP_LINK = "https://maps.google.com?q="
        }
    }
</script>
  
<style lang="scss">
    @import "@/assets/global.scss";

    .availability-detail {
        background: $pp-blue05;
        border-radius: 2px;
        margin: 0 20px 10px 20px;
        padding: 10px 10px 10px 15px;
        display: flex;
        flex-direction: column;

        .title-wrapper {
            h4 {
                font-weight: 500;
                margin: 0;
                display: inline-block;
            }

            span {
                color: $pp-grey60;
                font-weight: 400;
                font-size: 14px;
            }
        }

        .content {
            a {
                text-decoration: none;
                color: $pp-grey60;
                
                @media screen and (min-width: 768px) {
                    pointer-events: none;
                    cursor: pointer;
                }
            }

            span {
                font-size: 14px;
                vertical-align: bottom;
            }

            &.alert {
                margin-top: 10px;

                span {
                    color: $pp-blue;
                }
            }
        }

        svg {
            margin-right: 5px;
        }
    }
</style>